import * as React from "react"
import classNames from "classnames"
import Block from "@bappweb/block"
import Icon from "@bappweb/icon"
import Element from "@bappweb/element"
import Row from "@bappweb/row"
import "./style.scss"

const FormMessage = (props) => {

    return (
        <>
            {props.error && <Block type="div" className={classNames("form-msg", props.className)}>
                <Row>
                    <Block type="div" className="msg-icon">
                        <Icon
                            className=""
                            name="UiError"
                        />
                    </Block>
                    <Element type="p" className="col-11">{props.error}</Element>
                </Row>
            </Block>}
        </>
    )
}

export default FormMessage
